import render from './render'

export default {
  name: 'TasksType',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
